import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, ViewEncapsulation,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CommonFieldService} from "../../../../../../services/common/common-field.service";
import {AllocationRequest} from "../../../../../../model/clearing/allocation/allocation-request";
import {AccountType} from "../../../../../../model/exchange/account-type";
import {ClearingAllocationService} from "../../../../../../services/clearing/clearing-allocation.service";
import {AllocationSplitRequest} from "../../../../../../model/clearing/allocation/allocation-split-request";
import {ClearingSelectionInfo} from "../../../../../../model/clearing/clearing-selection-info";
import {SplitAllocationFormBaseComponent} from "../split-allocation-form-base.component";
import {Trade} from "../../../../../../model/clearing/trade";
import {ExchangeContractService} from "../../../../../../services/exchange/exchange-contract.service";
import {ThemeService} from "../../../../../../services/tools/theme.service";
import {ClearingTradeInfoService} from "../../../../../../services/clearing/clearing-trade-info.service";
import {ClearingInfoLoadRequest} from "../../../../../../model/clearing/clearing-info-load-request";
import {Observable} from "rxjs";
import {ApiValidation} from "../../../../../../model/api/api-validation";
import {ClearingSelectionSummary} from "../../../../../../model/clearing/clearing-selection-summary";
import {AppConfigService} from "../../../../../../services/app-config.service";
import {CcStorageService} from "../../../../../../services/common/cc-storage.service";
import {FieldsService} from "../../../../../../services/common/fields-service";

@Component({
  selector: 'app-clearing-split-allocation-form',
  templateUrl: './split-allocation-form.component.html',
  styleUrls: ['../split-allocation-form-base.component.scss', '../allocation-form-base.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SplitAllocationFormComponent extends SplitAllocationFormBaseComponent {

  constructor(el: ElementRef,
              cdref: ChangeDetectorRef,
              allocationService: ClearingAllocationService,
              exchangeContractService: ExchangeContractService,
              commonFieldService: CommonFieldService,
              appConfigService: AppConfigService,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService,
              themeService: ThemeService,
              private clearingTradeInfoService: ClearingTradeInfoService,
              storageService: CcStorageService,
              fieldsService: FieldsService) {
    super(el, cdref,
      allocationService,
      exchangeContractService,
      commonFieldService,
      appConfigService,
      messageService,
      confirmationService,
      translateService,
      themeService,
      storageService,
      fieldsService);
  }

  protected initConfigs() {
    super.initConfigs();
    this.dialogFormTitle = this.getTranslation('page.' + this.transPartKey + '.table.split_allocation');
  }

  public open(selectedIds: string[], firstTrade: Trade, clearingSelectionInfos: ClearingSelectionInfo[]): void {
    this.refreshConfig();
    this.ccFormDialog.reloadFieldValueMap();
    if (selectedIds && selectedIds.length > 0) {
      // this.formLoading = true;
      // this.allocationService.getSignificantTrades(selectedIds).subscribe(validation => {
      //   if (validation.success) {
      this.show();
      const allocationInProgress = new AllocationRequest();
      allocationInProgress.accountTypeCode = AccountType.GIVE_UP_CODE;
      allocationInProgress.tradeIds = selectedIds;
      // const firstTrade = validation.item[0];
      // allocationInProgress.owner = firstTrade.owner;
      allocationInProgress.businessDate = firstTrade.businessDate;
      allocationInProgress.clearingDate = firstTrade.clearingDate;
      allocationInProgress.clearingHouse = firstTrade.clearingHouse;
      allocationInProgress.exchangeCode = firstTrade.exchangeCode;
      allocationInProgress.side = firstTrade.side;
      allocationInProgress.tradeType = firstTrade.type;
      allocationInProgress.contractCode = firstTrade.contractCode;
      allocationInProgress.contractUnit = firstTrade.contractUnit;
      allocationInProgress.contractVersion = firstTrade.contractVersion;
      allocationInProgress.tradingEnvironment = firstTrade.tradingEnvironment;
      allocationInProgress.maturity = firstTrade.maturity;
      allocationInProgress.owner = firstTrade.owner;
      allocationInProgress.volume = clearingSelectionInfos[0].totalVolume - clearingSelectionInfos[0].totalClearingVolume;
      // clearingSelectionInfos.reduce((accumulator, clearingSelectionInfo) => {
      //   return accumulator + clearingSelectionInfo.totalVolume;
      // }, 0);
      allocationInProgress.openClose = firstTrade.openClose;
      allocationInProgress.callPut = firstTrade.callPut;
      allocationInProgress.strike = firstTrade.strike;
      // allocationInProgress.execTrader = firstTrade.operatorId;
      allocationInProgress.customOrderReference = firstTrade.customOrderReference;
      allocationInProgress.traderMemo = firstTrade.freeText2;
      this.originTraderMemo = firstTrade.freeText2;
      allocationInProgress.accountTypeCode = AccountType.GIVE_UP_CODE;
      // this.contracts = [{text:firstTrade.contractCode, id:allocationInProgress.contractId, value: undefined}];
      // console.log("------> allocationInProgress " + JSON.stringify(allocationInProgress));
      const allocationSplit: AllocationSplitRequest = {
        allocation: allocationInProgress.volume,
        accountTypeCode: AccountType.GIVE_UP_CODE,
        clearingHouse: firstTrade.clearingHouse,
        exchangeCode: firstTrade.exchangeCode,
        execTrader: firstTrade.operatorId
      };
      allocationInProgress.allocations.push(allocationSplit);
      allocationInProgress['formContractsCodes'] = new Set(clearingSelectionInfos.map(value => value.contract));
      this.openWithRecord(allocationInProgress);
      // } else {
      //   this.errorMessage(validation.message);
      //   this.loadingProgressValue = 100;
      // }
      // this.formLoading = false;
      // });
    }
  }

  public openWithRecord(newFormRecord: AllocationRequest): void {
    this.formRecord = newFormRecord;
    this.formContractsCodes = newFormRecord['formContractsCodes'];
    // this.refreshConfig();
    // this.ccFormDialog.reloadFieldValueMap();
    // this.refreshConfig();
    // this.ccFormDialog.reloadFieldValueMap();
    // this.loadingProgressValue = 0;
    // this.loadingProgressValue = 0;
    this.loadData();
    // this.filterExchanges();
    // this.filterTradingEnvs();
    // this.filterCustomers();
    // this.filterAccountTypes();
    // this.filterContracts();
    this.loadFooterInfos(this.formRecord.tradeIds);
    this.show();
  }

  protected doSave() {
    this.formLoading = true;
    this.formRecord.allocations.forEach(alloc => {
      if (this.manageGiveUpMssg23()) {
        alloc.broker = alloc.giveUpMessage3;
      }
    });
    this.allocationService.splitAllocationRequest(this.formRecord).subscribe(validation => {
      if (validation.success) {
        this.onSavedForm.emit({taskId: validation.item, formRecord: Object.assign({}, this.formRecord)});
        this.closeDialogForm();
      } else {
        this.errorMessage(validation.message);
      }
      this.formLoading = false;
    });
  }

  protected getSelectionSummary(summaryRequest: ClearingInfoLoadRequest): Observable<ApiValidation<ClearingSelectionSummary[]>> {
    return this.clearingTradeInfoService.getSelectionSummary(summaryRequest);
  }

  private getUniquePrice(clearingSelectionInfos: ClearingSelectionInfo[]): number | null {
    const uniquePrices = new Set(clearingSelectionInfos.map(info => info.price));
    return uniquePrices.size === 1 ? Array.from(uniquePrices)[0] : null;
  }
}
